module.exports = __webpack_public_path__ + "static/media/logo-game-controller-a.12501789.svg";